import { render, staticRenderFns } from "./oembed-section.vue?vue&type=template&id=45dab5fb&lang=pug&"
import script from "./oembed-section.vue?vue&type=script&lang=js&"
export * from "./oembed-section.vue?vue&type=script&lang=js&"
import style0 from "./oembed-section.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports